import {useMutation, useQueryClient} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type CreateProfileChallengeResponse = {
  id: number;
  status: string;
  time_control: string;
  rated: boolean;
  expiry: string;
};

// POST /players/<username>/challenge/ -- persists a ProfileChallenge (see
// chess repo's player_profile/services/challenge.py). Invalidates the
// profile query on success so `challenge_pending` flips to true without a
// manual refetch -- the reload-safe "pending" state itself is backed by this
// persisted record, not by anything cached client-side.
export const useCreateProfileChallengeApi = (username: string) => {
  const qc = useQueryClient();
  return useMutation(
    async (
      body: {time_control?: string; rated?: boolean} = {},
    ): Promise<CreateProfileChallengeResponse> =>
      (await ChessRestClient.post(`/players/${username}/challenge/`, body)).data,
    {
      onSuccess: () => {
        qc.invalidateQueries(['playerProfile', username]);
      },
    },
  );
};

export default useCreateProfileChallengeApi;
